import React from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import ListView from "../../../components/listView/ListView";
import studentReviewListViewMeta from "../../../configs/meta/listViewMeta/studentReviewsListViewMeta";

const StudentReview = () => (
  <React.Fragment>
    <Helmet title="Review Page" />
    <Container fluid className="p-0">
      <ListView meta={studentReviewListViewMeta()} title="Review List" />
    </Container>
  </React.Fragment>
);

export default StudentReview;
